module.exports = __webpack_public_path__ + "img/8ne.de110ce2.svg";